<template>
  <div id="jac-region-preview" class="preview-container">
    <v-card class="custom-card">
      <div class="custom-app-bar px-6 py-4">
        <v-row
          align="center"
          justify="space-between"
          class="ma-0 header-content"
        >
          <div class="d-flex flex-column">
            <h6 class="subtitle-text text-uppercase mb-1">
              Preview Region Data
            </h6>
            <h2 class="title-text text-h5 font-weight-bold mb-0">
              JAC Regional Preview
            </h2>
          </div>
          <v-btn @click="closePrompt" class="btn-close-icon" elevation="2" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </div>
      <v-container class="px-6 py-6" style="overflow: hidden">
        <v-card-title class="d-none"></v-card-title>
        <v-card-text class="pt-2">
          <div class="d-flex justify-content-center mb-4" v-if="LoadingFlag">
            <b-spinner
              variant="primary"
              type="grow"
              label="Loading..."
              style="color: #3a67b1"
            ></b-spinner>
          </div>
          <v-form ref="form1" lazy-validation v-on:submit.prevent>
            <v-container class="pa-0 mt-2">
              <v-row wrap class="mb-6 mx-0">
                <v-col cols="12" sm="6" lg="3" md="4" class="py-2 px-2">
                  <div class="info-card">
                    <div
                      class="info-icon"
                      style="background-color: rgba(58, 103, 177, 0.1)"
                    >
                      <v-icon color="#3A67B1">mdi-map-marker-outline</v-icon>
                    </div>
                    <div class="info-content">
                      <h6 class="label-text">Zone</h6>
                      <h5 class="value-text">{{ ZoneName }}</h5>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="4" class="py-2 px-2">
                  <div class="info-card">
                    <div
                      class="info-icon"
                      style="background-color: rgba(0, 151, 215, 0.1)"
                    >
                      <v-icon color="#0097D7">mdi-domain</v-icon>
                    </div>
                    <div class="info-content">
                      <h6 class="label-text">Region Name</h6>
                      <h5 class="value-text">{{ RegionName }}</h5>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="4" class="py-2 px-2">
                  <div class="info-card">
                    <div
                      class="info-icon"
                      style="background-color: rgba(237, 190, 56, 0.1)"
                    >
                      <v-icon color="#EDBE38">mdi-format-title</v-icon>
                    </div>
                    <div class="info-content">
                      <h6 class="label-text">Region Display Text</h6>
                      <h5 class="value-text">{{ RegionDisplayText }}</h5>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="3" class="py-2 px-2">
                  <div class="info-card">
                    <div
                      class="info-icon"
                      style="background-color: rgba(86, 189, 163, 0.1)"
                    >
                      <v-icon color="#56BDA3">mdi-toggle-switch-outline</v-icon>
                    </div>
                    <div class="info-content">
                      <h6 class="label-text mb-2">Active Status</h6>
                      <v-chip
                        :color="StatusColor"
                        class="white--text status-chip"
                        small
                      >
                        {{ ActiveStatusTxt }}
                      </v-chip>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-divider class="my-6 custom-divider mx-4"></v-divider>
              <v-row wrap>
                <v-col
                  align="center"
                  cols="12"
                  md="12"
                  class="d-flex justify-center mt-2"
                >
                  <v-btn
                    @click="closePrompt"
                    class="btn-close px-10 py-5"
                    elevation="0"
                    outlined
                  >
                    Close Preview
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  props: {
    previewRecordPrompt: {
      type: Boolean,
      required: true,
    },
    recordData: {
      required: true,
    },
  },
  data() {
    return {
      LoadingFlag: false,

      RegionName: "",
      RegionDisplayText: "",
      ZoneName: "",
      ActiveStatusTxt: "",
      StatusColor: "",

      PageInfo: {},
      PageTitle: "Preview JAC Region",
      PageDescription: "",
    };
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
      }
    },
  },
  mounted() {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jac_region",
        Action: "preview",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.LoadingFlag = false;

      this.getTableRecords();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt");
    },
    getTableRecords() {
      this.LoadingFlag = true;
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/jac-region/show";

      var upload = {
        UserInterface: 1,
        Region: this.recordData.Id,
      };

      const thisIns = this;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          thisIns.LoadingFlag = false;
          var flag = response.data.flag;
          var records = response.data.records;
          var output = response.data.output;

          if (flag == 1) {
            thisIns.RegionName = records.RegionName;
            thisIns.RegionDisplayText = records.RegionDisplayText;
            thisIns.ZoneName = records.ZoneName;
            thisIns.ActiveStatusTxt = records.ActiveStatusTxt;
            thisIns.StatusColor = records.StatusColor;
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          thisIns.LoadingFlag = false;
          console.log("error=" + error);
          thisIns.toast("error", error);
        });
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style scoped>
.preview-container {
  font-family: "Inter", "Roboto", sans-serif;
}

.custom-card {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 10px 30px -5px rgba(10, 15, 41, 0.08),
    0 4px 6px -2px rgba(10, 15, 41, 0.04) !important;
  background-color: #ffffff !important;
  border: 1px solid rgba(65, 64, 66, 0.05);
}

.custom-app-bar {
  background: linear-gradient(135deg, #3a67b1 0%, #2c508a 100%) !important;
  position: relative;
  overflow: hidden;
  border-bottom: none !important;
}
.custom-app-bar::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(
      circle at 15% 50%,
      rgba(255, 255, 255, 0.06) 0%,
      rgba(255, 255, 255, 0.06) 120px,
      transparent 120px
    ),
    radial-gradient(
      circle at 85% 30%,
      rgba(255, 255, 255, 0.04) 0%,
      rgba(255, 255, 255, 0.04) 180px,
      transparent 180px
    ),
    radial-gradient(
      circle at 50% 120%,
      rgba(255, 255, 255, 0.03) 0%,
      rgba(255, 255, 255, 0.03) 250px,
      transparent 250px
    );
  pointer-events: none;
}
.header-content {
  position: relative;
  z-index: 1;
}

.title-text {
  color: #ffffff !important;
  letter-spacing: 0.5px;
}

.subtitle-text {
  color: #edbe38 !important;
  letter-spacing: 1.5px;
  font-weight: 700;
  font-size: 0.75rem;
}

.btn-close-icon {
  background-color: rgba(255, 255, 255, 0.15) !important;
  color: #ffffff !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
  transition: all 0.3s ease;
}
.btn-close-icon:hover {
  background-color: rgba(255, 255, 255, 0.25) !important;
  transform: rotate(90deg);
}

.info-card {
  display: flex;
  align-items: flex-start;
  background-color: #f8f9fa;
  border: 1px solid rgba(65, 64, 66, 0.08);
  border-radius: 10px;
  padding: 20px;
  height: 100%;
  transition: all 0.3s ease;
}

.info-card:hover {
  background-color: #ffffff;
  box-shadow: 0 6px 16px rgba(10, 15, 41, 0.06);
  border-color: rgba(58, 103, 177, 0.2);
  transform: translateY(-2px);
}

.info-icon {
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
}

.info-content {
  display: flex;
  flex-direction: column;
}

.label-text {
  color: #414042; /* 90% black */
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.8rem;
  margin-bottom: 6px;
}

.value-text {
  color: #0a0f29; /* Off black */
  font-weight: 700;
  font-size: 1.15rem;
  margin-bottom: 0;
  word-break: break-word;
}

.status-chip {
  font-weight: 600;
  letter-spacing: 0.3px;
  padding: 0 16px;
  border-radius: 16px;
  font-size: 0.85rem;
}

.custom-divider {
  border-color: rgba(65, 64, 66, 0.08) !important;
}

.btn-close {
  background-color: #ffffff !important;
  color: #e53935 !important; /* Premium Red */
  border: 1px solid rgba(229, 57, 53, 0.3) !important;
  border-radius: 8px;
  text-transform: none !important;
  font-weight: 500;
  font-size: 0.95rem;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
}

.btn-close:hover {
  background-color: #e53935 !important;
  color: #ffffff !important;
  box-shadow: 0 4px 8px rgba(229, 57, 53, 0.2) !important;
  border-color: #e53935 !important;
  transform: translateY(-1px);
}
</style>
